import classes from './emergencyAlertTurnOffPopup.scss';
import overlayClasses from "./sceOverlayStyle.scss";
import FocusTrap from "focus-trap-react";
import { getLocalizedStringstwo } from "../../../centralizedLocalizedStringtwo";

const EaDisableTurnOffPopup = (props) => {
    let strings = getLocalizedStringstwo("EmergencyAlerts");
    let closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    return (
        <FocusTrap>
        <div>
            <div tabIndex="0" className={overlayClasses.sceOverlay}>
                <div className={overlayClasses.sceOverlayContent}>
                    <div className={classes.sceDialogBox}>
                        <div className={classes.textAlignLeft}>
                            <div className='row'>
                                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{strings.turnOffHeader} <button className={classes.iconClose}  onClick={props.handleClose} > <img  src={closeIcon} alt="close Icon" /></button></div>
                                <div className="col-xs-12">
                                    <div className={classes.sceEaTurnOffWarningSec}>
                                        <p>{strings.disablePopupText}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </FocusTrap>
    );
};

export default EaDisableTurnOffPopup;